module.exports = __webpack_public_path__ + "static/media/Monday_Step3_Image17.12100974.webp";